export default {
  "reliefFundActivity.thead.index": "#NO",
  "reliefFundActivity.thead.betProviderType": "BetProviderType",
  "reliefFundActivity.thead.deductBonus": "DeductBonus",
  "reliefFundActivity.thead.rewardCycle": "RewardCycle",

  "reliefFundActivity.thead.dailyRewardLimit": "DailyRewardLimit",
  "reliefFundActivity.thead.weeklyRewardLimit": "WeeklyRewardLimit",
  "reliefFundActivity.thead.monthlyRewardLimit": "MonthlyRewardLimit",
  "reliefFundActivity.thead.bonusWay": "bonusWay",
  "reliefFundActivity.thead.lossAmount": "LossAmount",
  "reliefFundActivity.thead.returnValue": "RebateRatio",
  "reliefFundActivity.thead.returnValue2": "RebateAmount",
  "reliefFundActivity.thead.rollover": "Rollover",

  "reliefFundActivity.thead.action": "Action",
  "reliefFundActivity.add": "Add",
  "reliefFundActivity.delete": "Delete",
};
